exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Business-media-list-component{width:80%;margin-left:10%;height:auto}.Business-media-list-component .bottom{height:1px;margin:5px auto 0;background-color:#ccc}.Business-media-list-component .ads{margin-top:60px;text-align:center}.Business-media-list-component .view-count{font-size:12px;color:#999}.Business-media-list-component .product-info .product{margin:40px 0;padding:20px;border:1px solid #eee}.Business-media-list-component .product-info .product .cover{position:relative}.Business-media-list-component .product-info .product .cover .price{background-color:transparent;color:#fff;position:absolute;bottom:0;right:10px}.Business-media-list-component .product-info .product .title{max-height:50px;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;color:#333}.Business-media-list-component .support{text-align:center;color:#ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/BusinessMediaList.scss
// module id = 628
// module chunks = 0